const Courses = () => import('@/views/website/courses/Courses.vue');
const Details = () => import('@/views/website/courses/details/Details.vue');

export default [
  {
    path: 'courses',
    name: 'courses-overview',
    meta: {
      label: 'Kurse & Seminare'
    },
    component: {
      render (c) { return c('router-view') }
    },
    children: [
      {
        path: '/',
        component: Courses
      },
      {
        path: ':id',
        name: 'courses-details',
        meta: {
          label: 'Details',
        },
        component: Details
      },
      {
        path: ':id/copy',
        name: 'courses-copy',
        meta: {
          label: 'Details',
        },
        component: Details
      },
    ]
  },
]
